module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACQAAAAkCAQAAABLCVATAAAAg0lEQVR4Ae3MMQ5AQBCF4Sds5U7iBg6g0+mUSrfRqVQu5QSsJYpBY/Mmkcj+0877EAp9WoRch+mxotFg7HGZDtOBKNZihv8xiRYz+jCFezc8U2KBxQRDMa4KK+yDMh6MoOyNMpgE41EtKIK5UinD7DXnfJYMQUmGpzrQtSQjyhEKvWsDJYtlVYinxL8AAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./src/assets/done.png
// module id = 1041
// module chunks = 0